import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { t } from '../../../app/i18n';
import { Link } from 'react-router';
import Table from 'antd/lib/table';
import Button from 'antd/lib/button';
import { ResponsiveTable, OpenFileLink } from '../../../common/components/data-display';
import { Search } from '../../account-management/components/filters';
import { Row, Col } from 'react-flexbox-grid';
import { currencyFormatter, formatDate, formatDateTime } from '../../../common/utils/helpers';
import { Input } from 'antd';
import Checkbox from 'antd/lib/checkbox';
import {
  disposeLoansActions
} from '../ducks';
import { getPrincipalBalance, getNominalBalance } from '../../../common/utils/mathHelpers';
import { getDelayOfPayment } from '../../../common/utils/helpers';
import _ from "lodash";

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators(
    {
      disposeLoans: disposeLoansActions.request,
    },
    dispatch
  ),
});

const { Column } = Table;
const formatAccountName = (accountName, loan, index, loans) => {
  if (index !== 0 && loan.accountId === loans[index - 1].accountId) {
    return {
      children: <span style={{ marginLeft: 40 }}>&#8627;</span>,
    };
  }
  return {
    children: <span><Link to={`/admin/accounts/${loan.accountId}/profile`}>{accountName}</Link><br />{loan.account.profileData.personalNumber}</span>,
  };
};

const getNumberOfPayments = (loan) => {
  const paidPayments = loan.installments.filter(function (item) {
    return item.status === "PAID";
  }).length;
  return {
    children: <span>{paidPayments}</span>
  };
};

const getPenaltyFeesSum = (penaltyFees) => {
  const sum = penaltyFees.filter(item => item.storno !== true).reduce((total,{unpaidAmount} ) => total + Number(unpaidAmount), 0) 
  return sum.toFixed(2)
}

//ZOSTATOK ISTINY
const getLeftOfAmount = (loan) => {
  return getPrincipalBalance(loan, loan.penaltyFees);
}
//MENOVITA HODNOTA
const getLoanNominalValue = (loan) => {
  return getNominalBalance(loan, loan.penaltyFees);
}

const defaultFilter = {
  search: '',
};

@translate()
@connect(null, mapDispatchToProps)
export default class DisposeLoanList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func,    
    isLoading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    actions: (text, loan) => (
      <span>
        <Link to={`/admin/loans/${loan.id}`}>{t('Detail')}</Link>
      </span>
    ),
  };

  state = {

    amountToBuy: 0,
    mapOfLoansToSell: new Map()
  };

  componentDidUpdate(prevProps, prevState){
    const { loans }  = this.props;
    if (!_.isEqual(prevProps.loans, loans) || (this.state.mapOfLoansToSell.size === 0 && loans.length > 0)){
      let amountToBuy = 0;
      let mapOfLoansToSell =new Map();
      // for (let loan of Array.from(loans)) {
      //   amountToBuy += Number(getLeftOfAmount(loan));
      //   mapOfLoansToSell.set(loan.loanNumber, { 
      //     nominalAmount:  getLoanNominalValue(loan),
      //     amount: getLeftOfAmount(loan)
      //   });
      // }
      // this.setState({ amountToBuy, mapOfLoansToSell });
    }
  }

  onSubmit = () => {
    const { action, filter } = this.props;
    action.disposeLoans({body: this.state.mapOfLoansToSell, allLoans: filter.allLoans});
    this.setState({
      amountToBuy: 0,
      mapOfLoansToSell: new Map()
    });
  };

  helpGenerator = (loan, comp) => {
    const onChecked = ({target}) => {
        let {amountToBuy, mapOfLoansToSell} = this.state;
        amountToBuy = 0;
        let input = document.getElementById(`inp${loan.loanNumber}`);
        if (target.nodeName === 'INPUT') {
          let checkbox = document.getElementsByName(`chk${loan.loanNumber}`);
          if (checkbox[0].checked) {
            mapOfLoansToSell.set(target.id.substring(3), {
              amount: target.value,
              nominalAmount: getLoanNominalValue(loan)
            });
          }
        } else {
          if (target.checked) {
            mapOfLoansToSell.set(loan.loanNumber, {
              amount: input.value,
              nominalAmount: getLoanNominalValue(loan)
            });
          } else {
            mapOfLoansToSell.delete(loan.loanNumber);
          }
        }
        mapOfLoansToSell.forEach((value, key) => {
          amountToBuy += Number(value.amount);
        });
        this.setState({ amountToBuy, mapOfLoansToSell }); 
      }
      if (comp === 'input') {
        return <Input id={`inp${loan.loanNumber}`} className="amountToBuyField" defaultValue={getLeftOfAmount(loan)} readOnly onChange={onChecked}></Input>
      }
      else if (comp === 'checkBox') {
        return <Checkbox name={`chk${loan.loanNumber}`} onChange={onChecked} checked={this.state.mapOfLoansToSell.has(loan.loanNumber)}/>
      }
  };

  render() {
    const {
      token,
      loans,
      filter,
      pagination,
      onTableChange,
      onFilterSearchChange,
      onFilterLoansChange,
      isLoading,
      actions,
      t,
    } = this.props;

    return (
      <div>
        <Row className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="loanSearch"
              onSearch={onFilterSearchChange}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Checkbox onChange={onFilterLoansChange}>Zobraziť pôžičky s prijatou platbou v posledných 90 dňoch</Checkbox>
          </Col>
        </Row>

        <ResponsiveTable
          dataSource={loans}
          rowKey={loan => loan.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
          rowClassName={loan => loan.blacklist.length > 0 ? 'blacklist-row' : (loan.nonpayer ? 'nonpayer-row' : '')}
        >
          <Column
            dataIndex="status"
            key="status"
            render={(accountName, loan, index) => this.helpGenerator(loan, 'checkBox')}
          />          
          <Column
            title={t('Meno dlžníka / Rodné číslo')}
            dataIndex="accountName"
            key="accountName"
            render={(accountName, loan, index) => formatAccountName(accountName,loan,index,loans)}
          />
          <Column
            title={t('Suma')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column 
            title={t('Dĺžka v mesiacoch')} 
            dataIndex="months" 
            key="months" 
            width="80px"
          />
          <Column 
            title={t('Uhradené splátky')}
            dataIndex="paymentsDone"
            key="paymentsDone"
            width="90px"
            render={(name, loan, index) => getNumberOfPayments(loan)} 
          />
          <Column 
            title={t('VS platby')}
            dataIndex="payments"
            key="payments"
            width="90px"
            render={(name, loan, index) => loan.payments.length > 0 ? loan.payments[0].variableSymbol : ""} 
          />
          <Column
            title={t('Dátum vytvorenia')}
            dataIndex="createdAt"
            key="createdAt"
            render={createdAt => formatDate(createdAt)}
          />
          <Column
            title={t('Zostatok istiny')}
            dataIndex="remainingAmount"
            key="remainingAmount"
            render={(name, loan, index) => getLeftOfAmount(loan)} 
          />
          <Column
            title={t('Počet dní omeškania')}
            dataIndex="installments"
            width="170px"
            key="installments"
            render={(name, loan, index) => getDelayOfPayment(loan.installments, loan.payments)}
          />
          <Column
            title={t('Sankčné poplatky')}
            dataIndex="penaltyFees"
            width="170px"
            key="penaltyFees"
            render={(name, loan, index) => getPenaltyFeesSum(loan.penaltyFees)}
          />
          <Column
            title={t('Menovitá hodnota')}
            dataIndex="account"
            key="account"
            render={(name, loan, index) => getLoanNominalValue(loan)} 
          />
          <Column
            title={t('Kupná cena')}
            width="160px"
            dataIndex="loan"
            key="loan"
            render={(name, loan, index) => this.helpGenerator(loan, 'input')}
          />
          <Column 
            title={t('Akcie')} 
            key="action" 
            render={actions} 
          />
        </ResponsiveTable>

        {token && (
          <div style={{float: 'right'}}>
            <OpenFileLink
              isButton
              href={`${process.env.REACT_APP_API_URL}/loan/disposalsRequest?token=${token}&search=${filter.search}&allLoans=${filter.allLoans}`}
              >
                {t('Export')}
            </OpenFileLink>
          </div>
          
        )}

        <div>
          <h2 size="default" style={{ display: 'inline' }}>{this.state.amountToBuy.toFixed(2)}</h2>
          <Button onClick={this.onSubmit} style={{ display: 'inline' }}>Zrealizovať odpredaj</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/DisposeLoanList.js